/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useContext } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTheme } from "@mui/material/styles";

import Environments from "../../../Environments";

import BasicButton from "../../../component/button/BasicButton";
import { useScreenSize } from "../../../component/Theme";

import UserDetailService, { UserDetailResponse } from "../../../logic/api/UserDetailService";
import SompoContext from "../../../logic/context/SompoContext";
import { showErrorMessage } from "../../../logic/hook/useDialogStateHelper";
import { logout } from "../../../logic/logout";

interface AgreementProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleLogin: () => void;
}

const userDetailService = new UserDetailService();

const Agreement = (props: AgreementProps) => {
    const theme = useTheme();
    const sompoContext = useContext(SompoContext);
    const { desktop } = useScreenSize();

    const { open, setOpen, handleLogin } = props;

    const [checked, setChecked] = React.useState(false);
    const onChangeAgree = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const onClickNext = () => {
        if (!Environments.MOCK) {
            const fetch = async () => {
                try {
                    // ユーザ情報を更新
                    await userDetailService.saveUserDetail(
                        {
                            fileData: "",
                            fileType: "",
                            lang: sompoContext.userDetail.lang,
                            familyNameJa: sompoContext.userDetail.familyNameJa,
                            password: "",
                            rePassword: "",
                            firstNameJa: sompoContext.userDetail.firstNameJa,
                            familyNameKanaJa: sompoContext.userDetail.familyNameKanaJa,
                            firstNameKanaJa: sompoContext.userDetail.firstNameKanaJa,
                            addressJa: sompoContext.userDetail.addressJa,
                            homePhone: sompoContext.userDetail.homePhone,
                            faxNumber: "1",
                            email1: sompoContext.userDetail.email1,
                            email2: sompoContext.userDetail.email2,
                            careerMemoJa: sompoContext.userDetail.careerMemoJa,
                            countryCode: sompoContext.userDetail.countryCode,
                            timeZone: sompoContext.userDetail.timeZone,
                            lederUserId: sompoContext.userDetail.lederUserId,
                            deleteImage: sompoContext.userDetail.deleteImage,
                        },
                        () => {
                            // NOP.
                        },
                        (error: any) => {
                            throw error;
                        }
                    );

                    // 再度ユーザ情報を取得して、コンテキスト書き換え
                    const userDetail = await new Promise<UserDetailResponse>((resolve, reject) => {
                        userDetailService.getUserDetail(
                                resolve,
                                reject
                            );
                        }
                    );
                    await sompoContext.setUserDetail(userDetail);

                    // 成功時、ログインする
                    handleLogin();
                } catch (error: any) {
                    console.error(error);
                    showErrorMessage({ message: "ユーザー情報の登録に失敗しました。", error });
                    logout();
                }
            };
            void fetch();
        } else {
            handleLogin();
        }
    };

    const closeModal = () => {
        setOpen(false);
        setChecked(false);
    };

    return (
        <Modal
            open={open}
            onClose={closeModal}
            sx={{
                width: desktop ? "100%" : "100vw",
                height: desktop ? "100%" : "100dvh",
                overflowY: "scroll",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Grid
                container
                direction="column"
                justifyContent="space-between"
                flexWrap="nowrap"
                alignItems="center"
                sx={{
                    width: desktop ? "80%" : "100vw",
                    height: desktop ? "80%" : "100dvh",
                    minWidth: desktop ? "400px" : "100vw",
                    maxWidth: desktop ? "1000px" : "100vw",
                    maxHeight: desktop ? "700px" : "100dvh",
                    minHeight: desktop ? "500px" : "100dvh",
                    overflowY: "scroll",
                    borderRadius: "10px",
                    bgcolor: "background.paper",
                    outline: "none",
                    padding: 5,
                }}
            >
                <Grid item>
                    <Typography
                        variant="h1"
                        sx={{
                            color: theme.palette.primary.main,
                            textAlign: "center",
                        }}
                    >
                        {"SOMPO Learning Hub"}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        sx={{
                            color: "#333",
                            fontSize: "0.9rem",
                        }}
                    >
                        利用規約を確認してください。
                    </Typography>
                </Grid>
                <Grid item sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box
                        sx={{
                            height: "300px",
                            width: "85%",
                            border: "1px solid #cccccc",
                            overflowWrap: "break-word",
                            overflowY: "scroll",
                            p: 2,
                        }}
                    >
                        {sompoContext.companySettings && (
                            <Typography sx={{ whiteSpace: "break-spaces", wordBreak: "break-all" }} component="pre">
                                {(sompoContext.companySettings?.ui?.agreementContents || []).join("\n")}
                            </Typography>
                        )}
                    </Box>
                </Grid>
                <Grid item sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                        control={<Checkbox checked={checked} onChange={onChangeAgree} inputProps={{ "aria-label": "controlled" }} />}
                        label="利用規約に同意する"
                    />
                </Grid>
                <Grid item>
                    <BasicButton disabled={!checked} onClick={onClickNext} label="次へ" />
                </Grid>
            </Grid>
        </Modal>
    );
};

export default Agreement;
